import PropTypes from "prop-types";

export const promo = PropTypes.arrayOf(
  PropTypes.shape({
    title: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
    bannerBgColor: PropTypes.string.isRequired,
    bannerImgUrl: PropTypes.string.isRequired,
    bannerHeader: PropTypes.string.isRequired,
    bannerText: PropTypes.string.isRequired,
    buttonColor: PropTypes.string.isRequired,
    actionText: PropTypes.string.isRequired,
    benefit1ImgSrc: PropTypes.string,
    benefit1Header: PropTypes.string,
    benefit1Text: PropTypes.string,
    benefit2ImgSrc: PropTypes.string,
    benefit2Header: PropTypes.string,
    benefit2Text: PropTypes.string,
    benefit3ImgSrc: PropTypes.string,
    benefit3Header: PropTypes.string,
    benefit3Text: PropTypes.string,
    benefit4ImgSrc: PropTypes.string,
    benefit4Header: PropTypes.string,
    benefit4Text: PropTypes.string,
    benefit5ImgSrc: PropTypes.string,
    benefit5Header: PropTypes.string,
    benefit5Text: PropTypes.string,
  }),
);
